import DataTypes from "~data";
import { Product } from "~data/Product";

export const cobrowseProducts = ["helloscreen", "userview", "cobrowsingapi"] as const satisfies ReadonlyArray<Product>;
export const cobrowseIntegrationsProducts = ["helloscreen", "userview"] as const satisfies ReadonlyArray<Product>;
export const cobrowseVisitorProductVariants = [
  "helloscreen_cobrowsing",
  "userview",
  "cobrowsingapi",
] as const satisfies ReadonlyArray<Exclude<DataTypes["Teams"]["productVariant"], null> | Product>;
export const cobrowseInstallProductVariants = [
  "helloscreen_cobrowsing",
  "helloscreen_presentation_sharing",
  "userview",
  "cobrowsingapi",
] as const satisfies ReadonlyArray<Exclude<DataTypes["Teams"]["productVariant"], null> | Product>;

export const cobrowsePrefixes = {
  cobrowsingapi: "co",
  helloscreen: "hs",
  userview: "uv",
} as const;
